export default __webpack_public_path__ + "static/media/mint.3f24ee6a.jpg";